export default {
  fetchTemplate({ commit }, payload) {
    commit('SET_TEMPLATE_DATA', payload)
  },
}
